module.exports = __webpack_public_path__ + "img/86.ce32141d.jpg";